import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { useWebsiteButton } from "../../customeHooks/useWebsiteButtons";
import { CreatedEvent } from "../../redux/features/event/event.types";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { formatDate } from "../../utils/helpers";

export const TrendingEventCard = ({ event }: { event: CreatedEvent }) => {
  const { goToEvent } = useWebsiteButton();

  return (
    <Link
      className="soft-shrink flex w-full max-w-[300px] flex-col overflow-hidden rounded-2xl bg-white"
      to={goToEvent(event?.slug!)}
    >
      <img
        className="h-[296px] w-[300px] object-cover"
        alt={`${event.name}`}
        src={event.image}
      />

      <div className="flex flex-1 flex-col gap-1 bg-white px-3 py-4">
        <p className="text-sm font-bold text-grey-600">
          {formatDate(event?.startDate, "ddd, MMMM DD, YYYY")}
        </p>

        <p className="font-fraunces text-xl leading-[120%] tracking-[-0.04em]">
          {event.name}
        </p>
      </div>
    </Link>
  );
};

export const TrendingCardLoader = () => {
  return (
    <div className="flex w-[300px] flex-col overflow-hidden rounded-2xl p-0">
      <Skeleton
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        baseColor={SKELETON_BASE_COLOR}
        width={"100%"}
        height={296}
        className="!mt-[-10px] pt-0"
      />

      <div className="flex flex-1 flex-col gap-1 bg-white px-3 py-4">
        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={"50%"}
          height={20}
        />

        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={"100%"}
          height={48}
        />
      </div>
    </div>
  );
};
